import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UserSearchDialogComponent } from './user-search-dialog.component';
import { UserSearchDialogService } from './user-search-dialog-service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { EnrollEmailDuplicateModule } from '../../enrollEmailDuplicate/enroll-email-duplicate.module';
import { AppMaterialModule } from '../../appMaterial/app-material.module';
import { RouterModule } from '@angular/router';
import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
  imports: [
    AppMaterialModule,
    FormsModule,
    EnrollEmailDuplicateModule,
    CommonModule,
    MatButtonModule,
    MatInputModule,
    RouterModule,
    TextMaskModule,
  ],
  exports: [UserSearchDialogComponent],
  declarations: [UserSearchDialogComponent],
  providers: [UserSearchDialogService],
  entryComponents: [UserSearchDialogComponent],
})
export class UserSearchDialogModule {}
